import React, { Component } from 'react';



export default class Alert extends Component {




  render() {
    return (

        <div hidden={this.props.AlertIsHidden} className={"modal-dialog alert alert-"+this.props.AlertModalType} role="document">

          {this.props.message}

          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>


        </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Alert.js